import React, {useEffect, useState} from 'react';
import {Button} from '../Button';
import {H6} from '../H6';
import {Section} from '../Section';
import {Select} from '../Select';
import {TextField} from '../TextField';
import {InfoItem} from './InfoItem';
import {nToast} from "../../plugins/reactToast";
import {TOrderDetail} from "../../types/types";
import {bankName, swapPayMethod} from "../../utils/texts";

type RefundAccountInfo = {
    refundAccountBank?: string,
    refundAccountNumber?: string
}

type AccountSectionProps = {
    order: TOrderDetail
    onChangeAccount: (accountInfo: RefundAccountInfo) => void
}

export const AccountSection = (props: AccountSectionProps) => {
    const {order, onChangeAccount} = props;
    const [toggle, setToggle] = useState(false);
    const [accountInfo, setAccountInfo] = useState<RefundAccountInfo>({})

    useEffect(() => {
        if (accountInfo) onChangeAccount(accountInfo)
    }, [accountInfo])

    return (
        <>
            {toggle ? (
                <Section className="space-y-4 text-13">
                    <div className="flex justify-between items-center border-b pb-2">
                        <H6 className="">품절시 환불 정보</H6>
                        <button
                            onClick={() => setToggle(true)}
                            className="rounded-md text-13 bg-gray-100 px-3 py-2"
                        >
                            계좌 변경
                        </button>
                    </div>

                    <div className="grid md:grid-cols-2 gap-y-4 gap-x-16">
                        <InfoItem title="결제수단" content={swapPayMethod(order.orderRequestExtra?.payMethod!)}/>
                        <InfoItem title="카드주(예금주)" content={order.customerName!}/>
                        <Select
                            label="카드사(은행명)"
                            className="border border-gray-400 pl-4"
                            onChange={(e) => setAccountInfo({...accountInfo, refundAccountBank: e.target.value})}
                        >
                            <option disabled selected hidden>
                                은행명을 선택해주세요.
                            </option>
                            {/* 은행 걍 전부다 해야되나 */}
                            <option value="KN">경남은행</option>
                            <option value="KJ">광주은행</option>
                            <option value="KM">국민은행</option>
                            <option value="KU">기업은행</option>
                            <option value="NH">농협</option>
                            <option value="DG">대구은행</option>
                            <option value="SL">SJ산림</option>
                            <option value="SU">산업은행</option>
                            <option value="K">케이뱅크</option>
                            <option value="SM">새마을금고</option>
                            <option value="SUP">수협</option>
                            <option value="CT">시티은행</option>
                            <option value="SH">신한은행</option>
                            <option value="SIN">신협</option>
                            <option value="WR">우리은행</option>
                            <option value="PO">우체국</option>
                            <option value="JJ">제주은행</option>
                            <option value="HS">HSBC</option>
                            <option value="SC">SC제일은행</option>
                            <option value="JB">전북은행</option>
                            <option value="HN">KEB하나은행</option>
                            <option value="BS">부산은행</option>
                        </Select>
                        <TextField type={'number'}
                                   label="계좌번호입력"
                                   placeholder="계좌번호를 입력해 주세요."
                                   onChange={(e) => setAccountInfo({
                                       ...accountInfo,
                                       refundAccountNumber: e.target.value
                                   })}
                        />
                    </div>

                    <div className="flex flex-row-reverse space-x-reverse space-x-4">
                        <Button
                            onClick={() => {
                                nToast('계좌정보 변경이 완료되었습니다.');
                                setToggle(false);
                            }}
                            text="저장"
                            className="filled-gray-900 px-12"
                        />
                        <Button text="취소" className="bg-gray-100  px-12"
                                onClick={() => {
                                    setToggle(false);
                                    setAccountInfo({})
                                }}
                        />
                    </div>
                </Section>
            ) : (
                <Section className="space-y-4 text-13">
                    <div className="flex justify-between items-center border-b pb-2 ">
                        <H6 className="">품절시 환불 정보</H6>
                        {(order.payMethod !== 'CARD' && order.payMethod !== 'KAKAO' && order.payMethod !== 'NAVER') && (
                            <button
                                onClick={() => setToggle(true)}
                                className="text-13 bg-gray-100 px-3 py-2 rounded-md"
                            >
                                계좌 변경
                            </button>
                        )}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <InfoItem title="결제수단" content={swapPayMethod(order.orderRequestExtra?.payMethod!)}/>
                        <InfoItem title="카드주(예금주)" content={order.customerName!}/>
                        <InfoItem title="카드사(은행명)"
                                  content={accountInfo.refundAccountNumber ? `${accountInfo.refundAccountNumber} (${bankName(accountInfo.refundAccountBank!)})` : '환불받으실 계좌를 입력해 주세요'}/>
                    </div>
                </Section>
            )}
        </>
    );
};
